/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TestimonialContent } from '../../models/testimonial-content';
import { TestimonialContentApiRespModel } from '../../models/testimonial-content-api-resp-model';

export interface ApiMasterTestimonialContentAddPost$Params {
      body?: TestimonialContent
}

export function apiMasterTestimonialContentAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterTestimonialContentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TestimonialContentApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTestimonialContentAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TestimonialContentApiRespModel>;
    })
  );
}

apiMasterTestimonialContentAddPost.PATH = '/api/Master/TestimonialContent/Add';
